'use strict';

require('details-polyfill');

function init() {
    [].forEach.call(document.querySelectorAll('details.wp-block-site-collapsible'), el => {
        el.addEventListener("toggle", function() {
            if (el.open) {
                // Build a selector using the data-group element from this element
                const selector = 'details.wp-block-site-collapsible[data-group="'+el.attributes['data-group'].value+'"]';
                // Get any other from the same group and close them
                [].forEach.call(document.querySelectorAll(selector), other => {
                    if (other == el) {
                        return;
                    }
                    other.removeAttribute("open");
                } )
            }
        }, false);
    })
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/detailsAccordion.js